export default __webpack_public_path__ + "static/media/rocket.62807f24.JPG";